import React from "react";

const Cancel = () => {
  return (
    <div>
      <h1>Cancel Payment</h1>
    </div>
  );
};

export default Cancel;
